import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import nl from './nl.json';
import pt from './pt.json';
import tr from './tr.json';
import vi from './vi.json';
import zh from './zh.json';
import pl from './pl.json';
import sv from './sv.json';
export var localizedMessages = {
  de: de,
  en: en,
  es: es,
  fr: fr,
  it: it,
  ja: ja,
  ko: ko,
  nl: nl,
  pt: pt,
  tr: tr,
  vi: vi,
  zh: zh,
  pl: pl,
  sv: sv
};
//# sourceMappingURL=__intergalactic-dynamic-locales.js.map